import { render } from "./TaxInformationSectionAddress.vue?vue&type=template&id=87dde2dc"
import script from "./TaxInformationSectionAddress.vue?vue&type=script&lang=js"
export * from "./TaxInformationSectionAddress.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__